import Dashboard from "views/Dashboard.js";
import Administration from "views/Administration.js";
import Payroll from "views/Payroll.js";
import Documents from "views/Documents.js";
import SchemeDocuments from "views/SchemeDocuments.js";
import { Home } from "lucide-react"


var routes = [
  {
    path: "/dashboard",
    name: "Home",
    icon: <Home className="h-4 w-4 mr-3 ml-1" />,
    component: <Dashboard />,
    layout: "/admin",
  },
  {
    path: "/administration",
    name: "Administration",
    icon: "nc-icon nc-single-copy-04",
    component: <Administration />,
    layout: "/admin",
  },
  {
    path: "/payroll",
    name: "Payroll",
    icon: "nc-icon nc-money-coins",
    component: <Payroll />,
    layout: "/admin",
  },
  {
    path: "/notifications",
    name: "Documents",
    icon: "nc-icon nc-map-big",
    component: <Documents />,
    layout: "/admin",
  },
  // {
  //   path: "/scheme-documents",
  //   name: " Scheme Documents",
  //   icon: "nc-icon nc-chart-pie-36",
  //   component: <SchemeDocuments />,
  //   layout: "/admin",
  // }
];
export default routes;
